export default __webpack_public_path__ + "1d486b60a6dd4deb5fcae5d4f67e06df.svg";